import * as React from "react"
import { Box } from "@mui/material";

import {ImageSkuBlock, SkuInfoBlock} from "@components"
import { useBuildExternalURL } from "@hooks"
import {stockShareSkuDetailsFilters} from "../../../signals";


export default function productSkuColumn() {
	return [{
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'SKU',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filter: false
		}
	}, {
		name: 'skuName',
		label: 'Product SKU',
		options: {
			filter: false,
			headerAlign: 'center',
			customBodyRowRender: (value, row) => <RenderProductSkuColumn value={value} row={row} />
		}
	}]
}

function RenderProductSkuColumn({ row, value }) {
	const { imageURL, productURL } = useBuildExternalURL({
		imageData: { skuID: row.skuID, siteID: row.siteID, productID: stockShareSkuDetailsFilters.value.productID, date: row.date },
		siteData: { siteID: row.siteID, productID: stockShareSkuDetailsFilters.value.productID }
	})

	return <Box sx={{ display: 'flex', justifyContent: 'center' }}>

		<ImageSkuBlock
			imageURL={imageURL}
			skuName={row.skuName}
			contentProps={{ sx: {mr: 2, ml: 0} }}
		/>

		<SkuInfoBlock
			sku={value}
			category={row.category}
			brand={row.brand}
			ean={row.ean}
			productURL={productURL}
		/>

	</Box>
}